"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcInnerDialog = function (props) {
    var show = props.show, size = props.size, _a = props.overlay, overlay = _a === void 0 ? true : _a, handleCancel = props.handleCancel, _b = props.width, width = _b === void 0 ? 375 : _b, dialogClassName = props.dialogClassName, backdropClassName = props.backdropClassName;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        show && overlay && react_1.default.createElement("div", { className: "fade modal-backdrop show " + backdropClassName }),
        react_1.default.createElement("div", { className: "modal bg-transparent " + (show ? 'show fade d-block' : 'd-none') },
            react_1.default.createElement("div", { className: "modal-dialog " + (size ? "modal-" + size : '') + " " + dialogClassName + " modal-dialog-centered modal-dialog-scrollable" },
                react_1.default.createElement("div", { className: "modal-content" },
                    react_1.default.createElement("div", { className: "modal-body" }, props.children))))));
};
exports.AcInnerDialog = AcInnerDialog;
AcInnerDialog.displayName = 'AcInnerDialog';
//# sourceMappingURL=AcInnerDialog.js.map